import { AmplitudeService } from './amplitude-service';

/**
 * 유저 행동 분석 정보 수집 서비스.
 */
export class AnalyticsService {
  private screenAnalytics: Record<string, string> | undefined = undefined;

  private amplitudeService?: AmplitudeService;

  public enable() {}

  public isLoaded() {
    return this.amplitudeService != null;
  }

  public async load(userID?: string) {
    this.amplitudeService = new AmplitudeService();
    await this.amplitudeService.load(userID);
  }

  public setUserProperties(properties: Record<string, any>) {
    this.amplitudeService?.setUserProperties(properties);
  }

  public setUser(userID: number | string | undefined) {
    this.amplitudeService?.setUser(userID);
  }

  public resetUser() {
    this.setUser(undefined);
  }

  public logLogin(params?: Record<string, any>) {
    this.amplitudeService?.logLogin(params);
  }

  public logSignUp(params?: Record<string, any>) {
    this.amplitudeService?.logSignUp(params);
  }

  public log(name: string, params?: Record<string, any>) {
    this.amplitudeService?.log(name, {
      ...this.screenAnalytics,
      ...params,
    });
  }

  public logScreenView(name?: string) {
    this.amplitudeService?.logScreenView({
      screen_name: name,
      ...this.screenAnalytics,
    });
  }

  public setScreenAnalytics(analytics: Record<string, string> | undefined) {
    this.screenAnalytics = analytics;
  }
}
